module.exports = __webpack_public_path__ + "static/media/refer_friend_site.e56707df.gif";